export default "__VITE_ASSET__s26Dj0L$__"